import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "modal-footer" }
const _hoisted_13 = {
  type: "submit",
  form: "expense-account-editor-form",
  class: "btn btn-primary"
}

import { computed, toRef } from 'vue'

    import { EditorState } from '@common/Common'
    import
        {
            CreateExpenseAccountEventPayload,
            UpdateCostAccountEventPayload
        } from '@Quest/Costs/Components/ExpenseAccountEditor'
    import type { ExpenseAccountEditorViewModel } from '@Quest/Costs/Components/ExpenseAccountEditor'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ExpenseAccountEditor',
  props: {
    viewModel: {}
  },
  emits: ["create-expense", "update-cost"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- computed ----------------

    const opened = computed(() => vm.value?.opened ?? false)

    const confirmButtonLabel = computed(() =>
        vm.value.state === EditorState.Creator ? 'Create' : 'Update'
    )

    const modalTitle = computed(() =>
        vm.value.state === EditorState.Creator
            ? 'New expense account'
            : 'Edit the cost account'
    )

    const canEditName = computed(() => vm.value.canEditName)
    const canEditClassification = computed(() => vm.value.canEditClassification)
    const subtotals = computed(() => vm.value.subtotals)

    // writable computeds (replace getter + setter pairs)

    const name = computed<string | null>({
        get: () => vm.value.name,
        set: v => { vm.value.name = v }
    })

    const classification = computed<string | null>({
        get: () => vm.value.classification,
        set: v => { vm.value.classification = v }
    })

    const subtotalId = computed<string | null>({
        get: () => vm.value.subtotalId,
        set: v => { vm.value.subtotalId = v }
    })

    // ---------------- actions ----------------

    function handleFormSubmit()
    {
        if (vm.value.state === EditorState.Creator)
        {
            emit(
                'create-expense',
                new CreateExpenseAccountEventPayload(
                    name.value,
                    classification.value,
                    subtotalId.value
                )
            )
        }
        else if (vm.value.state === EditorState.Editor)
        {
            emit(
                'update-cost',
                new UpdateCostAccountEventPayload(
                    vm.value.id,
                    name.value,
                    classification.value,
                    subtotalId.value
                )
            )
        }
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(modalTitle.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("form", {
                  id: "expense-account-editor-form",
                  onSubmit: _withModifiers(handleFormSubmit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Name:", -1 /* CACHED */)),
                    (canEditName.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
                          class: "form-control",
                          required: "",
                          maxlength: "100",
                          minlength: "2"
                        }, null, 512 /* NEED_PATCH */)), [
                          [
                            _vModelText,
                            name.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      : _createCommentVNode("v-if", true),
                    (!canEditName.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
                          class: "form-control",
                          readonly: ""
                        }, null, 512 /* NEED_PATCH */)), [
                          [_vModelText, name.value]
                        ])
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", { for: "subtotal" }, "Subtotal:", -1 /* CACHED */)),
                    _withDirectives(_createElementVNode("select", {
                      id: "subtotal",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subtotalId).value = $event)),
                      class: "form-control"
                    }, [
                      _cache[6] || (_cache[6] = _createElementVNode("option", { value: null }, "None", -1 /* CACHED */)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subtotals.value, (s) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: s.Id
                        }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_10))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 512 /* NEED_PATCH */), [
                      [_vModelSelect, subtotalId.value]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", { for: "classification" }, "Classification:", -1 /* CACHED */)),
                    (canEditClassification.value)
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          id: "classification",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((classification).value = $event)),
                          class: "form-control"
                        }, [...(_cache[8] || (_cache[8] = [
                          _createElementVNode("option", { value: "OpEx" }, "OpEx", -1 /* CACHED */),
                          _createElementVNode("option", { value: "COGS" }, "COGS", -1 /* CACHED */),
                          _createElementVNode("option", { value: "Other" }, "Other expenses", -1 /* CACHED */)
                        ]))], 512 /* NEED_PATCH */)), [
                          [_vModelSelect, classification.value]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 1,
                          type: "text",
                          readonly: "",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((classification).value = $event)),
                          class: "form-control"
                        }, null, 512 /* NEED_PATCH */)), [
                          [_vModelText, classification.value]
                        ])
                  ])
                ], 32 /* NEED_HYDRATION */)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: close,
                  class: "btn btn-outline-secondary"
                }, "Cancel"),
                _createElementVNode("button", _hoisted_13, _toDisplayString(confirmButtonLabel.value), 1 /* TEXT */)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})